class NotaFiscal {
  constructor() {
    this.id = null
    this.numero = ''
    this.dataHoraEmissao = ''
    this.dataEmissao = ''
    this.dataFatoGerador = ''
    this.ano = ''
    this.mes = ''
    this.discriminacaoServico = ''
    this.valorServico = 0
    this.valorDesconto = 0
    this.valorDescontoIncond = 0
    this.valorDescontoCond = 0
    this.valorDescontosDiversos = 0
    this.valorCredito = 0
    this.valorLiquido = 0
    this.valorBaseCalculo = 0
    this.aliquota = 0
    this.valorIss = 0
    this.valorInss = 0
    this.valorIr = 0
    this.valorCsll = 0
    this.valorPis = 0
    this.valorCofins = 0
    this.outrasRetencoes = 0
    this.tipoRecolhimento = ''
    this.pagaIssqnSomenteMunicipio = ''
    this.idNaturezaOperacao = ''
    this.idRegimeTributacao = ''
    this.regimeTrbPgIss = ''
    this.naturezaOperPgIss = ''
    this.optanteSs = ''
    this.incentivadorFiscal = ''
    this.pagaIss = ''
    this.codigoVerificacao = ''
    this.rpsLoteId = ''
    this.rpsLote = ''
    this.rpsNumero = ''
    this.rpsSerie = ''
    this.rpsDataEmissao = ''
    this.rpsTipo = ''
    this.numeroArt = ''
    this.numeroCei = ''
    this.dataVigenciaInicial = ''
    this.dataVigenciaFinal = ''
    this.version = ''
    this.localPrestacao = ''
    this.valorIrrf = 0
    this.valorSest = 0
    this.valorSenat = 0
    this.notaAvulsa = ''
    
    // Joins...
    this.idMunicPrestacao = null
    this.idCliente = null
    this.idUsuario = null
    this.idFichaRespostaPai = null
    this.idFluxoInstanciaAtividade = null
    this.idCntPrestador = null
    this.idSerie = null
    this.idPrestadorDados = null
    this.idTomadorDados = null
    this.idIntermediarioDados = null
    this.idAtividade = null
    this.idServicoItem = null
    this.idNotaSubstituida = null
  }
}

export default NotaFiscal
